import React from 'react';

interface ColorPickerProps {
  colors: string[];
  selected: string;
  onSelect: (color: string) => void;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({ colors, selected, onSelect }) => (
  <div className="cc-color-grid" aria-label="Body color">
    {colors.map(color => (
      <button
        type="button"
        key={color}
        className={`cc-color-swatch ${selected === color ? 'selected' : ''}`}
        style={{ backgroundColor: color }}
        onClick={() => onSelect(color)}
        aria-label={`Use color ${color}`}
        aria-pressed={selected === color}
        title={color}
      />
    ))}
  </div>
);
